import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpPrepareCallService } from '../../../services/http-prepare-call/http-prepare-call.service';
import { UtagHelperService } from '../../../services/utag-helper.service';
import { Observable } from 'rxjs';
import { showExportSettingsTooltip } from '../../../../models/export/export-settings-fe.model';
import { IExportConfiguration } from '../../../../models/export/export-configuration.model';

@Injectable({
  providedIn: 'root',
})
export class MydocumentsExportService extends HttpPrepareCallService {
  public constructor(
    protected override readonly httpClient: HttpClient,
    protected override utagHelperService: UtagHelperService
  ) {
    super(httpClient, utagHelperService);
  }

  public getExportSettings(
    sessionId: string,
    orderNumber: string
  ): Observable<any> {
    return this.httpClient.get(
      `${this.apiUrl}mydocuments/getUserMyDocsSettings(token='${sessionId}',orderNo='${orderNumber}')`,
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }

  public getAllAvailableExportSettings(
    sessionId: string,
    orderNumber: string
  ): Observable<any> {
    return this.httpClient.get(
      `${this.apiUrl}mydocuments/getAvailableZipSettings(token='${sessionId}',orderNo='${orderNumber}')`,
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }

  public getZipSettingsForSession(
    sessionId: string,
    orderNumber: string
  ): Observable<any> {
    return this.httpClient.get(
      `${this.apiUrl}mydocuments/getZipSettingsForSession(token='${sessionId}',orderNo='${orderNumber}')`,
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }

  public postExportSettings(
    sessionId: string,
    orderNumber: string
  ): Observable<any> {
    return this.httpClient.post(
      `${this.apiUrl}mydocuments/saveUserMyDocsSettings`,
      {
        token: sessionId,
        orderNo: orderNumber,
        settings: [
          {
            settingKey: showExportSettingsTooltip,
            value: 'false',
          },
        ],
      },
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }

  public postSaveUserDefaultSettings(
    sessionId: string,
    orderNo: string,
    saveAsDefault: boolean,
    exportConfiguration: IExportConfiguration
  ): Observable<any> {
    return this.httpClient.post(
      `${this.apiUrl}mydocuments/saveZipSettingsForSession`,
      {
        token: sessionId,
        orderNo: orderNo,
        saveAsDefault: saveAsDefault,
        zipSettings: exportConfiguration,
      },
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }
}
